module.exports = __webpack_public_path__ + "static/img/kxwz.e785d6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kxwz.png
// module id = Jv2/
// module chunks = 4